module.exports = {"theme":"hsla(170, 35%, 41%, 1)","link":"hsla(200, 35%, 20%, 1)","red":"hsla(0, 95%, 20%, 1)","errorRed":"#e85b5f","backgroundGray":"#eee","borderGray":"rgba(0,0,0,0.12)","black":"#222222","okGreen":"#369e36","highlightGreen":"rgba(54, 157, 54, 0.12)","solidGray":"#b5b5b5","sidebar":"#ebebeb"}


//////////////////
// WEBPACK FOOTER
// ./src/globals/colors.json
// module id = 2
// module chunks = 0